import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl, GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously} from "datasync-core";
import { globals} from "../Components/Globals/Globals";
import { produce } from 'immer';
const initialState = {
  paramsItems: [],
  paramCount: 0,
  loadParams_result:{status: 'idle', error: null},
  deleteParam_result:{status: 'idle', error: null},
}

// Create an async thunk for loading params
export const loadParams = createAsyncThunk(
  'params/loadParams',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.platform_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter params
        table_guid: globals.datasync.pf_params_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadParams::params response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting params
export const deleteParam = createAsyncThunk(
  'params/deleteParam',
  async (deletedParamObject) => {
    try {
      console.clear()
      console.log("deletedParamObject->", deletedParamObject)
      //Delete param from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedParamObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteParam->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedParamObject.rejectWithValue(error.message);
    }
  }
);

const paramSlice = createSlice({
  name: 'params',
  initialState,
  reducers: {
    addParam(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addParam: ", state.paramsItems)
          console.log("addParam: ", state.paramCount)
          console.log("addParam::action ->", action)  
        }
  
        state.paramCount++;
        state.paramsItems.push(action.payload);
      } catch (error) {
        console.error("Param added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateParam(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedParamObject = draft.paramsItems.find((param) => param.data_guid === action.payload.data_guid)
        console.log("updateParam: updatedParamObject->", updatedParamObject)
        if (updatedParamObject) {
          //update param in the array
          updatedParamObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateParam: Param not found in the array");
        }
      })
    },

    revertAllParams(state){
      console.log("paramSlice revertAllParams");
      state.paramsItems = [];
      state.paramCount = 0;
      state.loadParams_result = {status: 'idle', error: null};
      state.deleteParam_result = {status: 'idle', error: null};
    },

    revertStatusParam(state){
      if (globals.parameters.debugging)
        console.log("paramSlice revertStatusParam")

      state.deleteParam_result = {status: 'idle', error: null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadParams */
      .addCase(loadParams.pending, (state, action) => {
        state.loadParams_result = {status : "loading",error : null};
      })
      .addCase(loadParams.fulfilled, (state, action) => {
        if (action.payload.length > 0) {
          state.loadParams_result = {status : "succeeded",error : null};
          state.paramsItems = action.payload;
          state.paramCount= action.payload.length;
        }
        else {
          state.loadParams_result = {status : "succeeded",error : "No params found !!!"};
          state.paramsItems = [];
          state.paramCount= 0;
        }
      })
      .addCase(loadParams.rejected, (state, action) => {
        state.loadParams_result = {status : "failed",error : action.payload};
      })

      /* deleteParam */
      .addCase(deleteParam.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteParam.pending")
        console.log("deleteParam.pending -> action", action)
        state.deleteParam_result = {status : "deleting",error : null};
      })
      .addCase(deleteParam.fulfilled, (state,action) => {
        //Param sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteParam.fulfilled")
          console.log("deleteParam.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete param from local state
          draft.paramsItems = draft.paramsItems.filter((param, j) => param.data_guid !== action.payload.data_guid)
          draft.paramCount--;

          draft.deleteParam_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteParam.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteParam.rejected")
          console.log("deleteParam.rejected -> action", action)
        state.deleteParam_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addParam, updateParam, revertAllParams, revertStatusParam } = paramSlice.actions;
export default paramSlice.reducer;